import { createSelector } from "@ngrx/store";
import { getStudentCoursesModuleState, StudentCoursesState } from "../reducers";
import * as fromPage from "../reducers/page.reducer";

export const getPageState = createSelector(
    getStudentCoursesModuleState,
    (state: StudentCoursesState) => state.page
);

export const getPageFullscreen = createSelector(
    getPageState,
    fromPage.getPageFullscreen
);
